import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-top":"77px"} }

import { nextTick, onMounted, ref } from 'vue'
import AppFooterComponent from '@/components/AppFooterComponent.vue'
import AppSideBarComponent from '@/components/AppSideBarComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutBase',
  setup(__props) {

const height = ref(0)

onMounted(() => {
  nextTick(() => {
    height.value = document.getElementsByTagName('footer')[0]?.clientHeight ?? 0
  })
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppSideBarComponent),
    _createVNode(_component_router_view),
    _createVNode(AppFooterComponent)
  ]))
}
}

})